import Splide from '@splidejs/splide'

const sliders = {
  init() {
    this.popBrands()
    this.prodSliders()
    this.brands()
    this.prodCats()
    this.blogs()
    this.setProdThumbnailsSlider()
  },

    noSlider() {
    const noSlider = document.querySelectorAll(".jsNoSlider") as NodeListOf<HTMLElement>

    noSlider.forEach((item) => {
      const items = item.querySelectorAll(".splide__slide") as NodeListOf<HTMLElement>
      const minSlideNum = item.dataset.items as string
      if ((item.dataset.width && +item.dataset.width > window.innerWidth) || items.length <= +minSlideNum) {
        item.classList.remove("splide")

        item.classList.remove("jsProdSlider")
        item.firstElementChild?.classList.remove("splide__track")
        const list = item.firstElementChild?.firstElementChild
        list?.classList.remove("splide__list")
     

        if (items) {
          Array.from(items).forEach((el) => {
            const item = el as HTMLElement
            item.classList.remove("splide__slide")
          })
        }
      }
    })
  },
  resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider();
    });
  },

      brands() {
    const slider = document.getElementById('jsBrandsSlider') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        type: 'carousel',
        arrows: true,
        pagination: false,
      
        
        gap: '28px',

        perPage: 9,

          breakpoints: {
          1400: {
            perPage: 4,
         
          },

          990: {
            perPage: 4,
         
          },

          768: {
            perPage: 2,
            padding: { right: "30%" },
            arrows: false,
           
          },

          500: {
            perPage: 2,
            padding: { right: "30%" },
            arrows: false,
            gap: '15px',
            perMove: 1,
          
          },
        },
        
      }).mount()
    }
  },

      prodCats() {
    const slider = document.getElementById('jsPopCats') as
      | HTMLElement
      | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 6,
        
        type: 'loop',
        pagination: false,
        arrows: false,
        drag: false, 
        breakpoints: {
          1300: {
        
            drag: true, 
            perPage: 5, 
            perMove: 1,
          },

          1024: {
            drag: true, 
            perPage: 4, 
            perMove: 1,
          },

            768: {
            drag: true, 
            perPage: 3, 
            perMove: 1,
          },
          
            600: {
            drag: true, 
            perPage: 2, 
            perMove: 1,
          },
                    
            500: {
            type: 'carousel',
            drag: true, 
            perPage: 1,
            padding: { right: "30%" },
            perMove: 1,
          }
        }
      }).mount()
    }
  },

      setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as HTMLElement | undefined
    const thumbnails = document.getElementById("thumbnails") as HTMLElement | undefined

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'carousel',
        pagination: true,
        arrows: true,
        
        breakpoints: {
          1024: {
            arrows: false
          }
        }
      })

      const thumbnailsNav = new Splide(thumbnails, {
        
        isNavigation: true,
        type: 'carousel',
        pagination: false,
        heightRatio: 4,
        perPage: 4,
        arrow: true,
        gap: "20px",
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 3,
            heightRatio: 1,
            fixedHeight: "70px",
          },
        },
      })

      main.sync(thumbnailsNav)
      main.mount()
      thumbnailsNav.mount()
    }
  },



  popBrands() {
    const slider = document.getElementById('popBrands') as
      | HTMLElement
      | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 10,
        type: 'loop',
        pagination: false,
        arrows: false,
        drag: false, 
        height: '130px',
        breakpoints: {
          850: {
            drag: true, 
            perPage: 6, 
            perMove: 1,
            height: '100px',
          },

            768: {
            drag: true, 
            perPage: 6, 
            perMove: 1,
            height: '100px',
          },
          
            500: {
            drag: true, 
            perPage: 4, 
            perMove: 1,
            height: '100px',
          }
        }
      }).mount()
    }
  },

    blogs() {
    const slider = document.getElementById('blogs') as
      | HTMLElement
      | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 4,
        type: 'carousel',
        pagination: false,
        arrows: true,
        gap: '20px',
        breakpoints: {
          1024: {
            drag: true, 
            perPage: 2.5, 
            perMove: 1,
          },

            768: {
            drag: true, 
            perPage: 2, 
            perMove: 1,
          },
          
            500: {
            drag: true, 
            perPage: 1, 
            perMove: 1,
            padding: { right: "30%" },
          }
        }
      }).mount()
    }
  },

    prodSliders() {
    const slider = document.querySelectorAll('.jsProdSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
       type: 'carousel',
       rewind: false,
        arrow: true,
        pagination: false,
        speed: 2000,
        perMove: 1, 
        perPage: 5,
        gap: '25px',

        breakpoints: {
          1400: {
            perPage: 4,
            perMove: 1, 
         
          },

          990: {
            perPage: 3,
            perMove: 1, 
        
          },

          768: {
            perPage: 2,
            perMove: 1, 
            arrow: false,
    
          },

          500: {
            perPage: 1,
            perMove: 1, 
            arrow: false,
            gap: '20px',
            rewind: false,
            padding: { right: "30%" },
            
          },

          1200: {
            arrows: false,
          },
        },
      }).mount()
    })
  },

  
}

export default sliders
